<div *ngIf="packagesData" class="sample-packages" [finderScrollTo]="deepLink">
    <div class="title" *ngIf="packagesData.title">
        <h3 [finderAlignHeader]="packagesData">
            {{packagesData.title}}
        </h3>
        <finder-polyline *ngIf="packagesData.polyline || packagesData.mobilePolyline"
            [polyline]="packagesData.polyline"
            [mobilePolyline]="packagesData.mobilePolyline">
        </finder-polyline>
    </div>
    <h4 *ngIf="packagesData.subtitle" class="title"
        [finderAlignHeader]="packagesData"
        [finderAlignHeaderIsSubtitle]="true">
        {{ packagesData.subtitle }}
    </h4>
    <div class="packages-container" (finderElementChange)="focusOnReveal($event)"
        [finderMultipleItemsPerRow]="maxItemsPerRow"
        [finderHasTabletColumns]="packagesData.hasTabletColumns">
        <finder-package-card *ngFor="let package of packagesData.packages | slice:0:limit"
            class="package"
            [data]="package">
        </finder-package-card>
    </div>
    <finder-reveal-content *ngIf="cardCount > minimumLength" class="reveal-content"
        (currentState)="revealContent($event)"
        [showMoreText]="showMoreText"
        [showLessText]="showLessText">
    </finder-reveal-content>
</div>
